import { ReactComponent as InfoIcon } from "../../../../assets/svg/icons/info.svg";
import { parseUtcDate } from "../../../../utils/date/formatedDate";
import "./styles.css";
import { useTranslation } from "react-i18next";
import {
  isCompletedMonitoringStatus,
  translateMonitoringStatus,
  translateMonitoringTask,
} from "../../../../i18n/translateMonitoringTask";

type TableVisualizationRowProps = {
  evaluation: ITaskEvaluation;
  setSelectedId: (e: number) => void;
};

export default function TableVisualizationRowTask({
  evaluation,
  setSelectedId
}: TableVisualizationRowProps) {
  const { t } = useTranslation();
  const formatDateTimeByLocale = (date: Date | null) => {
    if (!date || Number.isNaN(date.getTime())) return "";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const datePart = `${day}/${month}/${year}`;

    const timePart = new Intl.DateTimeFormat(undefined, {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    }).format(date);

    return (
      <>
        {datePart}
        <br />
        {timePart}
      </>
    );
  };

  const created = parseUtcDate(evaluation?.created_at);
  const updated = parseUtcDate(evaluation?.updated_at);
  const synced = parseUtcDate(evaluation?.synced_at);
  const isCompleted = isCompletedMonitoringStatus(evaluation.status);

  return (
    <tr>
      <td>{evaluation.name}</td>
      <td>{translateMonitoringTask(evaluation.task)}</td>
      <td>{evaluation.micro_area_initials && !evaluation.micro_area_initials.includes("LT") ? evaluation.micro_area_initials : ""}</td>
      <td>{evaluation.micro_area_initials && evaluation.micro_area_initials.includes("LT") ? evaluation.micro_area_initials : ""}</td>
      <td>{translateMonitoringStatus(evaluation.status)}</td>
      <td>
        {evaluation?.created_at ?
          formatDateTimeByLocale(created)
          :
          ""}
      </td>
      <td>
        {evaluation?.updated_at ?
          formatDateTimeByLocale(updated)
          :
          isCompleted ? formatDateTimeByLocale(created) : ""
        }
      </td>
      <td>
        {formatDateTimeByLocale(synced)}
      </td>
      <td className="infoButton">
        <button title={t("commonUi.viewDetails")} style={{
          display: isCompleted ? "block" : "none",
          backgroundColor: "transparent"
        }}>
          <InfoIcon
            onClick={() => {
              setSelectedId(evaluation.id)
            }}
          />
        </button>
      </td>
    </tr>
  );
}
